import { faArrowToBottom } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { closeOverlay } from '../../actions/overlay';
import { APIACTIONS, OVERLAYS } from '../../constants';
import ConfirmationOverlay from '../overlay-confirmation';
import CreateProjectOverlay from '../overlay-create-project';
import IframeOverlay from '../overlay-iframe';
import ImageOverlay from '../overlay-image';
import PdfPreviewOverlay from '../overlay-pdf';
import ProjectAdditionalInfoOverlay from '../overlay-project-additional-info';
import SetPasswordOverlay from '../overlay-set-password';
import SetProjectsListOverlay from '../overlay-set-projects-list';
import TypeformOverlay from '../overlay-typeform';
import Portal from '../portal';
import Button, { BUTTON_SIZES } from '../styled/button';
import { BottomBar, CloseButton, Overlay, OverlayContentWrapper } from './styled';
import AccountActivationOverlay from '../AccountActivationOverlay/AccountActivationOverlay';
import TerrealAccountActivationOverlay from '../TerrealAccountActivationOverlay/TerrealAccountActivationOverlay';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import NewProjectOverlay from '../NewProjectOverlay/NewProjectOverlay';
const noOp = () => null;
class OverlayContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.wrapOverlay = this.wrapOverlay.bind(this);
    this.onTypeformSubmit = this.onTypeformSubmit.bind(this);
    this.getOverlayContent = this.getOverlayContent.bind(this);
    this.handlePropagation = this.handlePropagation.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
  }
  handleCloseOverlay(event) {
    if (!this.props.passwordChangeSuccess) {
      this.props.closeOverlay();
    }
  }
  handlePropagation(event) {
    event.stopPropagation();
  }
  onTypeformSubmit() {}
  wrapOverlay(content) {
    var _this = this;
    return function () {
      let downloadLink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return /*#__PURE__*/React.createElement(Portal, {
        portalRoot: "overlay-root"
      }, /*#__PURE__*/React.createElement(OverlayContentWrapper, {
        onClick: _this.handleCloseOverlay
      }, /*#__PURE__*/React.createElement(CloseButton, {
        onClick: _this.handleCloseOverlay
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faXmark
      })), /*#__PURE__*/React.createElement(Overlay, null, content), /*#__PURE__*/React.createElement(BottomBar, null, downloadLink && /*#__PURE__*/React.createElement(Button, {
        color: "white",
        size: BUTTON_SIZES.LARGE,
        outlined: true,
        as: "a",
        href: downloadLink,
        onClick: _this.handlePropagation,
        target: "_blank"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowToBottom
      }), "\xA0 T\xE9l\xE9charger"))), _this.props.createProjectOverlayOpened && /*#__PURE__*/React.createElement(CreateProjectOverlay, null));
    };
  }
  getOverlayContent(type) {
    return ({
      [OVERLAYS.IFRAME]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(IframeOverlay, {
        src: this.props.iframeOverlaySrc
      }))(),
      [OVERLAYS.CONFIRMATION[APIACTIONS.PANELSET]]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(ConfirmationOverlay, {
        title: "Votre panneau est-il install\xE9 ?",
        handleConfirm: () => {},
        handleReject: this.props.closeOverlay
      }))(),
      [OVERLAYS.CHANGEPASSWORD]: () => /*#__PURE__*/React.createElement(SetPasswordOverlay, null),
      [OVERLAYS.SELECTPROJECTSLIST]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(SetProjectsListOverlay, null))(),
      [OVERLAYS.IMAGE]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(ImageOverlay, {
        src: this.props.imageOverlaySrc
      }))(this.props.imageOverlaySrc),
      [OVERLAYS.PDF]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(PdfPreviewOverlay, {
        src: this.props.pdfOverlaySrc
      }))(this.props.pdfOverlaySrc),
      [OVERLAYS.TYPEFORM]: () => this.wrapOverlay(/*#__PURE__*/React.createElement(TypeformOverlay, {
        typeformUrl: this.props.typeformOverlayUrl,
        handleClose: this.props.closeOverlay,
        handleSubmit: this.onTypeformSubmit
      }))(),
      [OVERLAYS.CREATE_PROJECT]: () => /*#__PURE__*/React.createElement(CreateProjectOverlay, null),
      [OVERLAYS.PROJECT_ADDITIONAL_iNFO]: () => /*#__PURE__*/React.createElement(ProjectAdditionalInfoOverlay, null),
      [OVERLAYS.ACCOUNT_ACTIVATION]: () => /*#__PURE__*/React.createElement(AccountActivationOverlay, null),
      [OVERLAYS.TERREAL_ACCOUNT_ACTIVATION]: () => /*#__PURE__*/React.createElement(TerrealAccountActivationOverlay, null),
      [OVERLAYS.NEW_PROJECT]: () => /*#__PURE__*/React.createElement(NewProjectOverlay, null)
    }[type] || noOp)();
  }
  render() {
    return this.props.currentOverlayType ? this.getOverlayContent(this.props.currentOverlayType) : null;
  }
}
const mapStateToProps = _ref => {
  let {
    user,
    project,
    overlay
  } = _ref;
  return {
    passwordChangeSuccess: user.passwordChangeSuccess,
    projectId: project.id,
    currentOverlayType: overlay.currentOverlayType,
    iframeOverlaySrc: overlay.iframeOverlaySrc,
    confirmationOverlayTitle: overlay.confirmationOverlayTitle,
    confirmationActionId: overlay.confirmationActionId,
    imageOverlaySrc: overlay.imageOverlaySrc,
    pdfOverlaySrc: overlay.pdfOverlaySrc,
    typeformOverlayUrl: overlay.typeformOverlayUrl,
    typeformActionId: overlay.typeformActionId,
    createProjectOverlayOpened: overlay.createProjectOverlayOpened
  };
};
const mapDispatchToProps = dispatch => ({
  closeOverlay: () => dispatch(closeOverlay())
});
OverlayContainer.propTypes = {
  currentOverlayType: PropTypes.string,
  iframeOverlaySrc: PropTypes.string,
  imageOverlaySrc: PropTypes.string,
  pdfOverlaySrc: PropTypes.string,
  typeformOverlayUrl: PropTypes.string,
  confirmationOverlayTitle: PropTypes.string,
  confirmationActionId: PropTypes.string,
  passwordChangeSuccess: PropTypes.bool.isRequired,
  closeOverlay: PropTypes.func.isRequired,
  createProjectOverlayOpened: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(OverlayContainer);